(function () {
    'use strict';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('[data-region-slider]').forEach(function (slider) {
        var track = slider.querySelector('.bh-region-track');
        var controls = slider.querySelector('.bh-slider-controls');
        controls.hidden = false;
        function update() {
            controls.querySelector('[data-slide-prev]').disabled = track.scrollLeft < 2;
            controls.querySelector('[data-slide-next]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
        controls.addEventListener('click', function (e) {
            var button=e.target.closest('button');
            if (!button) return;
            track.scrollBy({left: (button.hasAttribute('data-slide-prev') ? -1 : 1) * track.clientWidth * .85, behavior: reduced.matches ? 'auto' : 'smooth'});
        });
        track.addEventListener('scroll', update, {passive: true});
        window.addEventListener('resize', update);
        update();
    });
    document.querySelectorAll('[data-contact-form]').forEach(function (form) {
        var status=form.querySelector('[role="status"]');
        var button=form.querySelector('button[type="submit"]');
        form.addEventListener('submit', async function (e) {
            e.preventDefault();
            if (!form.reportValidity()) return;
            if (form.elements.website.value) return;
            var endpoint=form.dataset.endpoint;
            var fields={name:form.elements.name.value.trim(),email:form.elements.email.value.trim(),message:form.elements.message.value.trim(),consent:form.elements.consent.checked};
            if (!fields.name || !fields.message) { status.textContent='Please enter your name and message.'; return; }
            if (!endpoint) {
                location.href='mailto:'+form.dataset.email+'?subject='+encodeURIComponent('Borneo History enquiry from '+fields.name)+'&body='+encodeURIComponent(fields.message+'\n\nFrom: '+fields.name+'\nEmail: '+fields.email+'\n\nI understand that Borneo History may contact me via email regarding my enquiry.');
                status.textContent='Your email app has been requested. Review and send the draft there; this form has not sent your message.';
                return;
            }
            button.disabled=true; status.textContent='Sending your message…';
            try {
                var url=new URL(endpoint,location.origin);
                if(url.protocol!=='https:') throw new Error('Invalid delivery configuration');
                var response=await fetch(url.href,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(fields),signal:AbortSignal.timeout(15000)});
                if(!response.ok)throw new Error('Delivery failed');
                status.textContent='Your enquiry has been submitted. Thank you for contacting Borneo History.';
                form.reset();
            } catch(err) { status.textContent='Your enquiry could not be submitted. Your text is still here. Please try again or use the email address alongside this form.'; }
            finally { button.disabled=false; }
        });
    });
}());
